// Must be imported FIRST so the agent is on the page before React mounts and
// captures the initial page-view + any startup errors.
import './newRelicBrowser';

import React from 'react';
import ReactDOM from 'react-dom/client';
import TagManager from 'react-gtm-module';
import { QueryClient, QueryClientProvider } from 'react-query';

import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { shouldErrorBeDisplayed } from './utils/shouldErrorBeDisplayed';

const tagManagerArgs = {
  gtmId: 'GTM-TPCTBQDR',
};

TagManager.initialize(tagManagerArgs);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
      useErrorBoundary: (error) => shouldErrorBeDisplayed(error),
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
